import { parse } from 'papaparse';
import * as Sentry from '@sentry/browser';

const parseCsv = async (file) => {
  if (!file) {
    return null;
  }

  try {
    const parsed = await new Promise((complete, error) =>
      parse(file, {
        complete,
        error,
        skipEmptyLines: true,
      })
    );

    return parsed;
  } catch (e) {
    Sentry.captureException(e);
    return null;
  }
};

export default parseCsv;
